import React from "react";
import Mohme1 from "../images/contenido/Papá Mohme abridora.jpg";
import Equipo from "../images/contenido/Equipo.jpg";
import Familia from "../images/contenido/FM 51 FAMILIA abridora.jpg";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";

const C1Nosotros = () => {
  return (
    <section id="nosotros" className="nosotros bg-red-dark">
      <Fade delay={100} triggerOnce>
        <div className="block-circle"></div>
        <div className="container d-flex">
          <div className="images">
            <img src={Mohme1} alt="Gustavo Mohme Llona" className="mohme-1" />
            <img
              src={Equipo}
              alt="Equipo Fundacion Gustavo Mohme Llona"
              className="mohme-2"
            />
            <img
              src={Familia}
              alt="Familia Fundacion Gustavo Mohme Llona"
              className="mohme-3"
            />
          </div>
          <div className="text">
            <h3 className="section-title">1. Nosotros</h3>
            <div className="block-transparent"></div>
            <p>
              Gustavo Mohme Llona fue una persona de firme voluntad en la
              defensa de los valores democráticos de libertad, respeto, justicia
              y verdad, por lo que la institución que lleva su nombre promueve
              el periodismo crítico y la formación ciudadana para lograr una
              sociedad peruana más justa, responsable y solidaria.
            </p>
            <div>
              <div className="button-link">
                <Link to="/gustavo-mohme-llona">
                  1.1 Gustavo Mohme Llona (1930-2000)
                </Link>
              </div>
              <div className="button-link">
                <Link to="/fundacion">1.2 La fundación</Link>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </section>
  );
};

export default C1Nosotros;
